import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // دالة الانتقال السلس
  const handleScroll = (id) => {
    const section = document.getElementById(id);

    if (section) {
      // لو موجود في نفس الصفحة → scroll مباشرة
      section.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    } else {
      // لو مش موجود → روح للصفحة الرئيسية ومعاها الهاش
      navigate(`/#${id}`);
      setIsOpen(false);
    }
  };

  // لما الصفحة الرئيسية تفتح ومعاها هاش، نعمل Scroll تلقائي
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const section = document.getElementById(id);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 300); // تأخير بسيط بعد تحميل الصفحة
      }
    }
  }, [location]);

  return (
    <header className="header">
      <div className="container">
        {/* اللوجو */}
        <div
          className="logo"
          onClick={() => handleScroll("home")}
          style={{ cursor: "pointer" }}
        >
          <img
            src="https://res.cloudinary.com/defcamc5x/image/upload/v1761237268/hpfuahcs7mps71hsixvo.png"
            alt="علاء الدين حامد"
          />
        </div>

        {/* زر المنيو للموبايل */}
        <div
          className={`menu-toggle ${isOpen ? "active" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* القايمة */}
        <nav className={`nav ${isOpen ? "open" : ""}`}>
          <ul className="navList">
            <li className="navItem" onClick={() => handleScroll("home")}>
              الرئيسية
            </li>
            <li className="navItem" onClick={() => handleScroll("about")}>
              السيرة الذاتية
            </li>
            <li className="navItem" onClick={() => handleScroll("services")}>
              خدمتنا
            </li>
            <li className="navItem" onClick={() => handleScroll("blog")}>
              المقالات
            </li>
            <li className="navItem" onClick={() => handleScroll("videos")}>
              فيديوهات
            </li>
            <li className="navItem btn" onClick={() => handleScroll("contact")}>
              اتصل بنا
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Nav;
